import axios from 'axios';
import { TSignedUrl } from 'types';

const getSignUrl = async (body: {
  filename: string;
  contentType: string;
  size: number;
  isPremiumFile?: boolean;
}): Promise<TSignedUrl> => {
  return await axios.post('upload/signed-url', body).then((response) => {
    return response.data;
  });
};

/** Must match backend PutObject CacheControl (signed header). */
const UPLOAD_CACHE_CONTROL = 'public, max-age=31536000, immutable';

const uploadFile = async (preSignedUrl: string, file: File) => {
  const res = await fetch(preSignedUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
      'Cache-Control': UPLOAD_CACHE_CONTROL,
    },
  });
  if (!res.ok) {
    console.error(res);
    throw new Error(res.statusText);
  }
  return res;
};

export { getSignUrl, uploadFile };
